<div class="row">
  <div class="col-md-12">
    <nb-card>
      <nb-card-header>{{ 'tytul.srodki-trwale' | translate }}</nb-card-header>  
      <nb-card-body>
        <section >
          <span>{{ 'akcja.wybierz-okres' | translate }}:</span>
        </section>
        <section class="mt-2 ml-3">
          <ngx-zakres-dat typWszystko="true" (zmianaZakresu)="onChangeZmianaZakresu($event)"></ngx-zakres-dat>
        </section>

        <section class="mt-2">
          <ngx-button-eksport-xls class="mr-2" [dane]="dane" [kolumny]="eksportKolumny" nazwa="srodki-trwale"></ngx-button-eksport-xls>
          <ngx-button-eksport-pdf class="mr-2" [dane]="dane" [kolumny]="eksportKolumny" [kolumnyStyle]="eksportPdfKolumnyStyle" nazwa="srodki-trwale" nazwaRaportu="{{ 'tytul.srodki-trwale' | translate }}" [zakresDat]="zakresDat"></ngx-button-eksport-pdf>
          <button nbButton size="small" (click)="wyswietlanieFiltrow = !wyswietlanieFiltrow">{{ wyswietlanieFiltrow ? ('akcja.ukryj-filtry' | translate) : ('akcja.pokaz-filtry' | translate) }}</button>
        </section>

        <!-- Widok desktopowy - tabela -->
        <div class="desktop-view">
          <ngx-datatable
            class="bootstrap"
            [rows]="dane"
            [summaryRow]="true"
            [summaryPosition]="'bottom'"
            [headerHeight]="45"
            [rowHeight]="45"
            [footerHeight]="50"
            [columnMode]="'flex'"
            [messages]="komunikatyTabeli"
            [limit]="15"
          >
          <ngx-datatable-column
            headerClass="font-weight-bold" 
            prop="liczbaPorzadkowa"
            name="{{ 'etykieta.lp' | translate }}"
            cellClass="text-right"
            [flexGrow]="1"
            [summaryFunc]=null
          >
          </ngx-datatable-column>
          <ngx-datatable-column 
            prop="nazwa"
            name="{{ 'etykieta.nazwa' | translate }}"
            cellClass="text-left"
            [flexGrow]="2"
            [headerTemplate]="hdrTpl"
          >
          </ngx-datatable-column>

          <ngx-datatable-column 
            prop="dataZakupu"
            name="{{ 'etykieta.data-zakupu' | translate }}"
            cellClass="text-center"
            [flexGrow]="1"
            [headerTemplate]="hdrTpl"
          >
          </ngx-datatable-column>

          <ngx-datatable-column 
            prop="wartoscPoczatkowa"
            name="{{ 'etykieta.wartosc-poczatkowa' | translate }}"
            cellClass="text-right"
            [flexGrow]="1"
            [headerTemplate]="hdrTpl"
            [summaryFunc]="sumaKwota"
          >
            <ng-template let-value="value" ngx-datatable-cell-template>
              {{value | kwota}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column 
            prop="amortyzacjaMiesieczna"
            name="{{ 'etykieta.amortyzacja-miesieczna' | translate }}"
            cellClass="text-right"
            [flexGrow]="1"
            [headerTemplate]="hdrTpl"
            [summaryFunc]="sumaKwota"
          >
            <ng-template let-value="value" ngx-datatable-cell-template>
              {{value | kwota}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column 
            prop="amortyzacjaJednorazowa"
            name="{{ 'etykieta.amortyzacja-jednorazowa' | translate }}"
            cellClass="text-right"
            [flexGrow]="1"
            [headerTemplate]="hdrTpl"
            [summaryFunc]="sumaKwota"
          >
            <ng-template let-value="value" ngx-datatable-cell-template>
              {{value | kwota}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column 
            prop="miesiacPoczatkowy"
            name="{{ 'etykieta.miesiac-poczatkowy' | translate }}"
            cellClass="text-center"
            [flexGrow]="1"
            [headerTemplate]="hdrTpl"
          >
          </ngx-datatable-column>

          <ngx-datatable-column 
            prop="miesiacKoncowy"
            name="{{ 'etykieta.miesiac-koncowy' | translate }}"
            cellClass="text-center"
            [flexGrow]="1"
            [headerTemplate]="hdrTpl"
          >
          </ngx-datatable-column>

          <ngx-datatable-column 
            prop="dataZbycia"
            name="{{ 'etykieta.data-zbycia' | translate }}"
            cellClass="text-center"
            [flexGrow]="1"
            [headerTemplate]="hdrTpl"
          >
          </ngx-datatable-column>

          <ngx-datatable-column 
            prop="przyczynaZbycia"
            name="{{ 'etykieta.przyczyna-zbycia' | translate }}"
            cellClass="text-left"
            [flexGrow]="1"
            [headerTemplate]="hdrTpl"
          >
          </ngx-datatable-column>

          </ngx-datatable>
        </div>

        <!-- Widok mobilny - kafelki -->
        <div class="mobile-view">
          <!-- Filtr dla widoku mobilnego -->
          <div class="mobile-filter mb-3" *ngIf="wyswietlanieFiltrow">
            <input
              nbInput
              fullWidth
              type="search"
              placeholder="{{ 'etykieta.szukaj' | translate }}"
              (input)="updateFilterMobile($event)"
            />
          </div>

          <!-- Kafelki z danymi -->
          <div class="row">
            <div class="col-12 mb-3" *ngFor="let item of dane; let i = index">
              <nb-card>
                <nb-card-header>
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="font-weight-bold">{{ item.nazwa }}</span>
                    <span class="text-muted">#{{ item.liczbaPorzadkowa }}</span>
                  </div>
                </nb-card-header>
                <nb-card-body>
                  <div class="row mb-2">
                    <div class="col-6">
                      <div class="stat-label">{{ 'etykieta.data-zakupu' | translate }}</div>
                      <div class="stat-value">{{ item.dataZakupu }}</div>
                    </div>
                    <div class="col-6">
                      <div class="stat-label">{{ 'etykieta.wartosc-poczatkowa' | translate }}</div>
                      <div class="stat-value text-primary">{{ item.wartoscPoczatkowa | kwota }}</div>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-6">
                      <div class="stat-label">{{ 'etykieta.amortyzacja-miesieczna' | translate }}</div>
                      <div class="stat-value text-info">{{ item.amortyzacjaMiesieczna | kwota }}</div>
                    </div>
                    <div class="col-6">
                      <div class="stat-label">{{ 'etykieta.amortyzacja-jednorazowa' | translate }}</div>
                      <div class="stat-value text-warning">{{ item.amortyzacjaJednorazowa | kwota }}</div>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-6">
                      <div class="stat-label">{{ 'etykieta.miesiac-poczatkowy' | translate }}</div>
                      <div class="stat-value">{{ item.miesiacPoczatkowy }}</div>
                    </div>
                    <div class="col-6">
                      <div class="stat-label">{{ 'etykieta.miesiac-koncowy' | translate }}</div>
                      <div class="stat-value">{{ item.miesiacKoncowy }}</div>
                    </div>
                  </div>
                  <div class="row" *ngIf="item.dataZbycia">
                    <div class="col-6">
                      <div class="stat-label">{{ 'etykieta.data-zbycia' | translate }}</div>
                      <div class="stat-value">{{ item.dataZbycia }}</div>
                    </div>
                    <div class="col-6">
                      <div class="stat-label">{{ 'etykieta.przyczyna-zbycia' | translate }}</div>
                      <div class="stat-value">{{ item.przyczynaZbycia }}</div>
                    </div>
                  </div>
                </nb-card-body>
              </nb-card>
            </div>
          </div>

          <!-- Podsumowanie dla widoku mobilnego -->
          <nb-card accent="info" *ngIf="dane && dane.length > 0">
            <nb-card-header>
              <span class="font-weight-bold">{{ 'etykieta.podsumowanie' | translate }}</span>
            </nb-card-header>
            <nb-card-body>
              <div class="row">
                <div class="col-4">
                  <div class="stat-label">{{ 'etykieta.suma-wartosci' | translate }}</div>
                  <div class="stat-value text-primary">{{ sumaWartoscPoczatkowa() | kwota }}</div>
                </div>
                <div class="col-4">
                  <div class="stat-label">{{ 'etykieta.suma-amortyzacji-mies' | translate }}</div>
                  <div class="stat-value text-info">{{ sumaAmortyzacjaMiesieczna() | kwota }}</div>
                </div>
                <div class="col-4">
                  <div class="stat-label">{{ 'etykieta.suma-amortyzacji-jedn' | translate }}</div>
                  <div class="stat-value text-warning">{{ sumaAmortyzacjaJednorazowa() | kwota }}</div>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>

        <ng-template #hdrTpl let-column="column" let-sort="sortFn">
          <span class="font-weight-bold text-wrap" (click)="sort()">{{ column.name }}</span>
          <span [hidden] = "!wyswietlanieFiltrow">
            <br/>
            <input
              nbInput
              fieldSize="small"
              type="search"
              class="w-75"
              (input)="updateFilter($event, column.prop)"
            />
          </span>
        </ng-template>
      </nb-card-body>
    </nb-card>
  </div>
</div>